import * as React from 'react';
import closeIcon from 'src/assets/images/close-ic.png'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ProductCompareRepository from "../../../repository/ProductCompareRepository";
import { useProductStore } from 'src/hooks/product';

const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const { carouselState: { currentSlide } } = rest;
    return (
        <div className='arrows-container'>
            <a className={currentSlide === 0 ? 'disable arrows arrows-left' : 'arrows arrows-left'}
                onClick={() => previous()}><i className='fa fa-chevron-circle-left'></i></a>
            <a className='arrows arrows-right' onClick={() => validateNext() && next()}><i className='fa fa-chevron-circle-right'></i></a>
        </div>
    );
};

const validateNext = () => {
    const compareBox = document.getElementsByClassName('compare-item-list-outer')[0].offsetWidth;
    const activeItem = document.getElementsByClassName('react-multi-carousel-track')[0].clientWidth;
    return (compareBox - (activeItem + 35) < 0) ? true : false;
}

const responsive = {
    superLargeDesktop: {
        breakpoint: { max: 4000, min: 3000 },
        items: 7
    },
    largedesktop: {
        breakpoint: { max: 3000, min: 1400 },
        items: 7
    },
    desktop: {
        breakpoint: { max: 1400, min: 1024 },
        items: 6
    },
    tabletlandscape: {
        breakpoint: { max: 1024, min: 767 },
        items: 5
    },
    tablet: {
        breakpoint: { max: 767, min: 567 },
        items: 3
    },
    mobile: {
        breakpoint: { max: 567, min: 0 },
        items: 2
    }
};

const BottomCompareItemSlider = (props) => {
    const [{ model_ProductCompare_data }, { }, { }] = useProductStore();
    return (
        <>
            <div className="col-12 col-md p-0 position-relative compare-item-list-wrapper">
                <div className="compare-item-list-background" />
                {model_ProductCompare_data && Object.keys(model_ProductCompare_data).length > 0 &&
                    <>
                        <div className="compare-item-list-outer">
                            <Carousel
                                swipeable={false}
                                draggable={true}
                                showDots={false}
                                responsive={responsive}
                                ssr={true} // means to render carousel on server-side.
                                infinite={false}
                                autoPlay={false}
                                autoPlaySpeed={12000}
                                keyBoardControl={true}
                                customTransition="all .5"
                                transitionDuration={500}
                                containerClass="carousel-container"
                                removeArrowOnDeviceType={["mobile"]}
                                dotListClass="custom-dot-list-style"
                                itemClass="carousel-item-padding-40-px"
                                renderArrowsWhenDisabled={true}
                                arrows={false}
                                customButtonGroup={<ButtonGroup />}

                            >
                                {

                                    Object.keys(model_ProductCompare_data).map((v, i) => (
                                        <div key={v} className="comapre-item">
                                            <div className='pe-3'>
                                                <p className="product-link">{model_ProductCompare_data[v].ERPMFRPartNumber ? model_ProductCompare_data[v].ERPMFRPartNumber : ''}</p>
                                                <span
                                                    className="manufacturer">{model_ProductCompare_data[v].ManufacturerName ? model_ProductCompare_data[v].ManufacturerName : ''}</span>
                                            </div>
                                            <div className="close-ic"
                                                onClick={async () => {
                                                    await new ProductCompareRepository().toggleSingleProduct(model_ProductCompare_data[v])
                                                    // new BroadcastChannel('product-compare-toggled').postMessage({}); // // 13546
                                                    await new ProductCompareRepository().fetchAllData();
                                                }}
                                            >
                                                <img src={closeIcon} />
                                            </div>
                                        </div>
                                    ))

                                }

                            </Carousel>
                        </div>
                    </>
                }
            </div>
        </>
    );
}

export default BottomCompareItemSlider;